import angular from 'angular';
import CategoriesFilter from './categories-filter.component';
import categoriesInputFilter from './categories-input-filter/categories-input-filter';
import CategoriesSliderFilterModule from './categories-slider-filter/categories-slider-filter';
import CategoriesAccordionModule from './categories-accordion/categories-accordion';


import CategoriesSynchronousFilterModule from './categories-synchronous-filter/categories-synchronous-filter';

let CategoriesFilterModule = angular.module('catalog.categoriesFilter', [
  categoriesInputFilter.name,
  CategoriesSliderFilterModule.name,
  CategoriesSynchronousFilterModule.name,
  CategoriesAccordionModule.name
])
  .component('categoriesFilter', CategoriesFilter);

export default CategoriesFilterModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/categories-filter/categories-filter.js
 **/